import React, { CSSProperties } from "react";

interface IProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}
const TotumNativeLogo: React.FC<IProps> = (props: IProps) => {
    const { color } = props;
    return (
        <div style={props?.style}>
            <svg
                width={props.svgWidth || "32"}
                height={props.svgHeight || "32"}
                className="images-icon"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 253.5 248"
            >
                <circle cx="126.7" cy="124" r="122.2" style={{ fill: "#001529" }} />
                <path
                    fill={color ? color : "#ffffff"}
                    d="M126.7 19.7C69.2 19.7 20.1 66 20.1 124s49 104.3 106.6 104.3c57.8 0 106.6-46 106.6-104.3S184.5 19.7 126.7 19.7zm0 187.5c-46.1 0-83.2-37.1-83.2-83.2s37.1-83.2 83.2-83.2c46.5 0 83.2 36.7 83.2 83.2s-36.7 83.2-83.2 83.2z"
                />
                <path
                    fill={color ? color : "#ffffff"}
                    d="M88.7 86.6c2.7 6.7 4.6 13.9 5.8 21.3h20.7v63.6h22v-63.6h26.4V86.6H88.7z"
                />
            </svg>
        </div>
    );
};

export default TotumNativeLogo;
